import { COLORS } from '../../constants';

export const StyledScroll = `
::-webkit-scrollbar {
    width: 11px;
}

::-webkit-scrollbar-track {
  background: ${COLORS.black}; 
}

::-webkit-scrollbar-thumb {
  background: ${COLORS.seaBlue}!important;
}
`;
